export default __webpack_public_path__ + "a770c2e27b05474fe9f03538722704db.obj";